/**
 * Model Catalog — registry of supported AI models and their properties.
 */
export const thinkingLevelValues = ["none", "low", "medium", "high"];
export const modelRecommendationSourceValues = ["planner", "user"];
export const MODEL_CATALOG = [
    {
        id: "claude-sonnet-4.6",
        displayName: "Claude Sonnet 4.6",
        family: "anthropic",
        supportsThinking: true,
        defaultThinking: "medium",
        tier: 1,
        costMultiplier: 1.0,
    },
    {
        id: "claude-opus-4.6",
        displayName: "Claude Opus 4.6",
        family: "anthropic",
        supportsThinking: true,
        defaultThinking: "high",
        tier: 3,
        costMultiplier: 5.0,
    },
    {
        id: "gpt-5.5",
        displayName: "GPT-5.5",
        family: "openai",
        supportsThinking: false,
        defaultThinking: "none",
        tier: 3,
        costMultiplier: 7.5,
    },
];
export function getModelById(id) {
    return MODEL_CATALOG.find((m) => m.id === id);
}
export function getModelDisplayName(id) {
    return getModelById(id)?.displayName;
}
export function isValidModelId(id) {
    return MODEL_CATALOG.some((m) => m.id === id);
}
/**
 * Models a person may pick for the chat turns of a request conversation
 * (ENG-390). The epic_request job payload's optional `model` must be one of
 * these; save/repair turns always use the stronger default model.
 */
export const CONVERSATION_CHAT_MODELS = [
    { id: "claude-haiku-5-5", label: "Haiku 5.5" },
    { id: "claude-sonnet-5-5", label: "Sonnet 5.5" },
    { id: "claude-opus-5-5", label: "Opus 5.5" },
    { id: "claude-fable-5-1", label: "Fable 5.1" },
];
export const CONVERSATION_CHAT_MODEL_IDS = CONVERSATION_CHAT_MODELS.map((m) => m.id);
/** The default chat model: fast, so replies feel instant. */
export const DEFAULT_CONVERSATION_CHAT_MODEL = "claude-haiku-5-5";
export function isConversationChatModel(value) {
    return typeof value === "string" && CONVERSATION_CHAT_MODEL_IDS.includes(value);
}
//# sourceMappingURL=model-catalog.js.map